module.exports = __webpack_public_path__ + "static/img/11.711203ab.png";